<!--
    Params
      - node - node to edit
-->

<template>
  <ValidationObserver
    ref="flowNodeObserver"
    v-slot="{ valid }" >
    <b-modal
      ref="flowNodeModal"
      modal-class="node-modal"
      :body-class="['dark-background']"
      :size="size"
      centered
      @hidden="reset"
    >
      <template slot="modal-header">
        <Vnodes
          :vnodes="title"/>
      </template>

      <!-- Placeholder for node type component -->
      <FlowTriggerDetails
        v-if="node && node.type === 'trigger'"
        :node="node"
        :submit="working"
        @submitted="submitted"
        @error="error" />

      <template slot="modal-footer">
        <div class="modal-footer__buttons flex flex-row flex-nowrap">
          <b-button
            :disabled="working"
            @click="hide" >{{ cancelButtonText }}</b-button>
          <b-button
            class=""
            :disabled="!valid || working"
            :variant="buttonVariant"
            :class="{loading: working}"
            @click="confirm" >
            <span>{{ confirmButtonText }}</span>
            <Spinner
              v-if="working"
              class="absolute"
              :size="14"
              :thickness="2"
              :color="SBColors.white" />
          </b-button>
        </div>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';

import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import Spinner from '@/components/common/Spinner';
import ToasterMixin from '@/mixins/Toaster';
import FlowTriggerDetails from './FlowTriggerDetails';

export default {
  name: 'FlowNodeModalComponent',
  components: {
    Spinner,
    FlowTriggerDetails,
    Vnodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      editMode: false,
      confirmButtonText: 'Save',
      variant: 'info',
      size: '',
      buttonVariant: 'primary',
      cancelButtonText: 'Cancel',
      working: false,
      node: null,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      flowsDefinitionsUI: 'flows/flowsDefinitionsUI', // TODO delete
      updatingFlow: 'flows/updatingFlow',
    }),
    title() {
      const h = this.$createElement;
      const title = h(
        'h2',
        { class: 'flex center-all' },
        [
          this.editMode ? 'Edit' : 'Add',
          this.node && this.node.typeSubcode && this.flowsDefinitionsUI.triggers[this.node.typeSubcode].icon && this.flowsDefinitionsUI.triggers[this.node.typeSubcode].icon.dark ? h(
            'img',
            {
              attrs: {
                src: this.flowsDefinitionsUI.triggers[this.node.typeSubcode].icon.dark,
                alt: '',
              },
              style: {
                width: '16px',
                height: '16px',
              },
            },
          ) : '',
          this.node && this.node.typeSubcode ? this.flowsDefinitionsUI.triggers[this.node.typeSubcode].name : '',
        ],
      );
      return title;
    },
  },
  beforeMount() {
    this.$eventBus.$on('showFlowNodeModal', (params) => {
      if (!this.updatingFlow) {
        this.show(params);
      } else {
        this.showToaster('Wait for the flow to update before editing a block.', null, null, 'warning');
      }
    });
  },
  methods: {
    show(params) {
      this.working = false;
      if (params.node) {
        this.editMode = true;
        this.node = params.node;
      }
      this.$refs.flowNodeModal.show();
      setTimeout(() => {
        this.$refs.flowNodeObserver.validate();
      }, 0);
    },
    hide() {
      this.$refs.flowNodeModal.hide();
    },
    /** Setting the working to true triggers the submit action in the specific component. */
    confirm() {
      this.$refs.flowNodeObserver.validate()
        .then((valid) => {
          if (valid) {
            this.working = true;
          }
        });
    },
    submitted(data) {
      this.hide();
    },
    error(error) {
      this.working = false;
      this.showToaster('There was an error. Try again later.', null, null, 'error');
    },
    reset() {
      this.size = '';
      this.working = false;
      this.$refs.flowNodeObserver.reset();
    },
  },
};
</script>

<style lang="scss">
.node-modal {
  .modal-content {
    .modal-header {
      padding: 20px;
      box-shadow: none;
      border-bottom: solid 1px $greyBorderModal;
      display: flex;
      flex-direction: column;

      h2 {
        font-size: 16px;
        font-weight: 500 !important;
        color: $blackPrimary;
        margin-bottom: 0px;
        gap: 10px;
      }

      p {
        font-size: 14px;
        color: $blackUltralight;
      }
    }
    .modal-body {
      padding: 20px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      color: $blackPrimary;
      background-color: $greyUltralight;
    }
    .modal-footer {
      border-top: solid 1px $greyBorderModal;
      align-items: center;
      flex-direction: row;
    }
    .modal-footer>* {
      margin: 0;
    }
    .modal-footer__message {
      // style if needed
    }
    .modal-footer__buttons {
      // style if needed
      .btn.loading {
        position: relative;

        span {
          visibility: hidden;
        }

        .loader {
          position: absolute;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
    .modal-footer__undo-warning {
      color: $redPrimary;
      font-size: 14px;
      font-weight: 400;
      // icon 4px from text
      .sb2-icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
